let storage;
export default storage = {
  set(key:string,value:string){
    localStorage.setItem(key, value);
  },
  get(key:string,defaultValue:string=''):string{
    let value = localStorage.getItem(key)
    if(!value){
      value = defaultValue
    }
    return value;
  },
  remove(key:string){
    localStorage.removeSchemaItem(key);
  }
}
